module.exports = __webpack_public_path__ + "static/media/pn.8b1dcfe6.svg";